import { apiGet } from '../../api'

export const set_default_group = group_id => {
  return apiGet({
    endpoint: `groups/set_default_group?id=${group_id}`
  })
}
